
import React, {FC} from 'react';
import {LINK_EXT, Routes} from 'constants/index';

import * as styles from './styles.module.scss';

const promptLink = (record: string) => {
	const host = 'https://airtable.com';
	const base = 'appHAp4mtbp2VAxPX';
	const tbl = 'tblRziHFtPfX9XaMQ';
	const view = 'viwWjPijW1USzpm1G';
	return `${host}/${base}/${tbl}/${view}/${record}?blocks=hide`;
};

export type MetadataProps = {
	cache?: string
	prompt: string
}

export const Metadata: FC<MetadataProps> = ({cache, prompt}) => {
	return (
		<div className={styles.wrapper}>
			<h3>Metadata:</h3>
			{cache && (
				<div>
					Report: <a
						href={`${Routes.reportDexa}/${cache}`}
						{...LINK_EXT()}
					>{cache}</a>
				</div>
			)}
			<div>
				Prompt: <a
					href={promptLink(prompt)}
					{...LINK_EXT()}
				>{prompt}</a>
			</div>
		</div>
	);
};
